import '../styles/legado/digix-ui/temas/horus.scss'

import { Carregamento } from '@digix-ui/componentes'

import { useCallback, useEffect, useMemo } from 'react'
import ReactGA from 'react-ga4'

import { obterRotas } from '@/config'
import { analyticsConfig } from '@/config/analytics'

import { useAuth, useProductFruits, useToast } from '@/hooks'
import { useFeatureFlag } from '@/hooks/use-feature-flag'
import type { TipoDeToast } from '@/hooks/use-toast'
import type { PermissaoDeRota } from '@/models'

import { RouterCreator } from '@/router'

interface ErroGenericoArmazenado {
  titulo: string
  texto?: string
  tipo?: TipoDeToast
}

export function AppContext(): JSX.Element {
  const contextoAutenticacao = useAuth()

  useProductFruits()

  const integracaoPapelZeroHabilitada = useFeatureFlag('integracao_papel_zero')

  const rotas = useMemo(
    () => obterRotas(!!integracaoPapelZeroHabilitada),
    [integracaoPapelZeroHabilitada]
  )

  const temPermissao = useCallback(
    (permissoes: PermissaoDeRota[]) =>
      permissoes.every(permissao =>
        permissao === 'admin'
          ? !!contextoAutenticacao.is_admin
          : !!contextoAutenticacao[permissao]
      ),
    [contextoAutenticacao]
  )

  const toast = useToast()

  useEffect(() => {
    if (
      analyticsConfig.googleAnalyticsId &&
      process.env.REACT_APP_NODE_ENV === 'production'
    ) {
      ReactGA.initialize(analyticsConfig.googleAnalyticsId)
    }
  }, [])

  useEffect(() => {
    const erroGenerico = sessionStorage.getItem('erro-generico')
    if (!erroGenerico) return

    setTimeout(() => {
      sessionStorage.removeItem('erro-generico')

      const erro = JSON.parse(erroGenerico) as ErroGenericoArmazenado

      toast(erro.titulo, {
        descricao: erro.texto,
        tipo: erro.tipo,
        duracao: 8000,
      })
    }, 800)
  }, [])

  if (contextoAutenticacao.carregandoSistema) {
    return <Carregamento telaCheia /> // Evita que os componentes sejam renderizados antes da autenticação ser completada
  }

  return <RouterCreator rotas={rotas} temPermissao={temPermissao} />
}
